import { SeonSessionIdProvider } from '@patrianna/analytics'
import { DialogProvider } from '@patrianna/dialog-manager'

import SaveWebReferrer from 'containers/SaveWebReferrer'
import TurnOffSpinnerInButtons from 'containers/TurnOffSpinnerInButtons'
import VisibilityProvider from 'containers/VisibilityProvider'
import { useAnalytics } from 'hooks/analytics/useAnalytics'
import useClearVerificationEmailLinkTimer from 'hooks/useClearVerificationEmailLinkTimer'
import useMainLayout from 'hooks/useMainLayout'
import usePaymentDialogs from 'hooks/usePaymentDialogs'
import useResetWelcomeEmailTimer from 'hooks/useResetWelcomeEmailTimer'
import { seonV6Instanse } from 'services/seon'
import dialogs, { sessionDialogsProps } from 'src/dialogs'
import { useAppSelector } from 'src/store/hooks'
import { isLoggedInSelector } from 'store/modules/user/selectors'
import { ThemeProvider as MtThemeProvider } from 'theme/themeProvider'

import type { ComponentType, ReactNode } from 'react'

type LayoutProps = {
  children: ReactNode
  isDarkMode?: boolean
}

export default function Layout({ children, isDarkMode }: LayoutProps) {
  const loggedIn = useAppSelector(isLoggedInSelector)

  useMainLayout()
  useAnalytics()
  usePaymentDialogs()
  useClearVerificationEmailLinkTimer()
  useResetWelcomeEmailTimer()

  return (
    <>
      <SaveWebReferrer />
      <TurnOffSpinnerInButtons />
      {loggedIn && <VisibilityProvider />}

      <MtThemeProvider initialDarkMode={isDarkMode}>
        {children}

        <SeonSessionIdProvider seon={seonV6Instanse}>
          <DialogProvider
            dialogsByName={dialogs as Record<string, ComponentType<any>>}
            sessionDialogsProps={sessionDialogsProps}
          />
        </SeonSessionIdProvider>
      </MtThemeProvider>
    </>
  )
}
